import { useState, useEffect } from "react";
import axios from "axios";

const useFilteredOrders = (query, skipRequest = false) => {
  const [orders, setOrders] = useState(null);
  const [loading, setLoading] = useState(query && query.length === 1 ? true : false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (skipRequest) { return; }
    const fetchOrders = async () => {
      setLoading(true);
      setError(null);
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const token = localStorage.getItem("authToken");
        var user_id = localStorage.getItem("user");
        if (!user_id) {
          const pathParts = window.location.pathname.split("/").filter(Boolean);
          user_id = pathParts[0] || null;
        }
        const response = await axios.get(`${apiUrl}/api/fetch_orders/`, {
          headers: { "Content-Type": "application/json", },
          params: { state: user_id, query, limit: 10 },
        });
        setOrders(response.data.data.orders.edges || []);
      } catch (err) {
        setError("Error fetching orders.");
        window.location.reload();
      } finally {
        setLoading(false);
      }
    };
    const timeoutId = setTimeout(fetchOrders, 500); //debounce api
    return () => clearTimeout(timeoutId);
  }, [query]);

  return { orders, loading, error };
};

export default useFilteredOrders;